/* eslint-disable prefer-const */
(function () {
    'use strict';

    angular
        .module('ib-apis-form-module')
        .factory('ApisFormTransformer', ApisFormTransformer);

    ApisFormTransformer.$inject = ['$filter', 'CheckinAppConstants', 'localStorageService', 'ApisFormConstants', 'UtilsService', 'ContentPreprocessorService'];
    function ApisFormTransformer ($filter, CheckinAppConstants, localStorageService, ApisFormConstants, UtilsService, ContentPreprocessorService) {
        const service = {
            transformApisView: transformApisView,
            generatePassengerPendingAQQ: generatePassengerPendingAQQ,
            checkUpdatedPassengersStatus: checkUpdatedPassengersStatus,
            generateUpdateApisRequest: generateUpdateApisRequest,
            generateAdditionalInformationRequest: generateAdditionalInformationRequest,
            generateNewsLetterInfo: generateNewsLetterInfo,
            generateCustomerTravelInfo: generateCustomerTravelInfo,
            updatePassengersDataContact: updatePassengersDataContact,
            updateDestinationPassengers: updateDestinationPassengers,
            updateOriginPassengers: updateOriginPassengers,
            generateListErrorPassengers: generateListErrorPassengers,
            updateStatusPassenger: updateStatusPassenger,
            getDocument: getDocument,
            updateDocument: updateDocument,
            getPositionPassenger: getPositionPassenger
        };
        return service;
        ////////////////

        function transformApisView (apisInfo, frequentFlyersInfo, countriesList, prefixes, statesList, travelInfo, gdprData) {
            const apisFormTransformed = {
                passengers: [],
                companylist: frequentFlyersInfo.slice(),
                prefixList: prefixes.slice(),
                countries: countriesList.slice(),
                states: statesList.slice(),
                currentPassenger: 0,
                showNextPasLink: false,
                showBoardingCard: false,
                showUseForAll: { state: false, passengerId: null },
                contactDataInfo: {
                    allTrueInfo: false,
                    boardingCard: true,
                    formStatus: ApisFormConstants.TAB_STATES.NOT_TOUCHED

                }
            };
            const prefixMarket = UtilsService.getPrefixFromMarket();
            let initialDisruptionContactData = localStorageService.get('disruptionContactApis');
            let defaultPrefix = null, gdprInfo = {}, defaultCountry = {}, i;

            localStorageService.remove('counterDocs');
            apisFormTransformed.companylist.unshift({ airlineName: $filter('translate')('CKI_COMBO_BLANK'), iataCompanyCode: 'CKI_COMBO_BLANK' });

            if (apisFormTransformed.prefixList && apisFormTransformed.prefixList.length > 0) {
                defaultPrefix = prefixMarket.code;
                apisFormTransformed.prefixList.shift();
            }

            if (apisFormTransformed.countries && apisFormTransformed.countries.length > 0) {
                defaultCountry = apisFormTransformed.countries[0];
                apisFormTransformed.countries.shift();
            }

            filterSelectedPassengers(apisInfo.passengersSecurityInformation);

            if (apisInfo.passengersSecurityInformation.length > 1) {
                apisFormTransformed.showBoardingCard = true;
                apisFormTransformed.showUseForAll.state = true;
                apisFormTransformed.showUseForAll.passengerId = apisInfo.passengersSecurityInformation[0].id;
            }

            for (i = 0; i < apisInfo.passengersSecurityInformation.length; i++) {
                const passengerSecurityInfo = apisInfo.passengersSecurityInformation[i];
                apisFormTransformed.passengers.push(generatePassengerApisInfo(passengerSecurityInfo, i, false, null));

                // Add data if passenger is INFANT
                if (passengerSecurityInfo.infantPassengerSecurityInformation) {
                    apisFormTransformed.passengers.push(generatePassengerApisInfo(passengerSecurityInfo.infantPassengerSecurityInformation, i, true, passengerSecurityInfo));
                }
            }

            if (gdprData) {
                gdprInfo = angular.copy(gdprData);
                gdprInfo.text = ContentPreprocessorService.processContent(gdprInfo.text, 'gdprInfo');
            }

            if (apisFormTransformed.passengers.length > 1) apisFormTransformed.passengers[0].view.showInTransitForAll = true;

            return { passengersInfo: apisFormTransformed, gdprInfo: gdprInfo };

            function filterSelectedPassengers (apisPassengers) {
                let passengersSelectedAPIS = localStorageService.get('passengersAPIS'), pasFound, pasIndex, pasApisIndex;
                for (pasIndex = 0; pasIndex < apisPassengers.length; pasIndex++) {
                    pasFound = false; pasApisIndex = 0;
                    while (!pasFound && pasApisIndex < passengersSelectedAPIS.length) {
                        pasFound = parseInt(apisPassengers[pasIndex].id) === passengersSelectedAPIS[pasApisIndex];
                        pasApisIndex++;
                    }
                    if (!pasFound) {
                        apisPassengers.splice(pasIndex, 1);
                        pasIndex--;
                    }
                }
            }

            function generatePassengerApisInfo (pasApisInfo, index, isInfant, parentInfo) {
                let pasApisInfoTransformed = { id: pasApisInfo.id, title: pasApisInfo.title, infantInfo: null, showContactData: true, view: { showOptions: false, showInTransit: false, showInTransitForAll: false, errorList: [] }, travelInfo: false }, documents, viewValues, cachedInfo = localStorageService.get('bookingInfo');
                pasApisInfoTransformed.basicInfo = generateBasicInfo(pasApisInfo?.id || parentInfo?.id, pasApisInfo, isInfant);
                pasApisInfoTransformed.boardingCard = true;
                pasApisInfoTransformed.status = checkStatusPassenger(pasApisInfo, cachedInfo);
                pasApisInfoTransformed.formStatus = ApisFormConstants.TAB_STATES.NOT_TOUCHED;
                pasApisInfoTransformed.requiredFields = pasApisInfo.requiredFields || [];
                pasApisInfoTransformed.basicInfo.gender = pasApisInfo.gender;
                pasApisInfoTransformed.travelInfo = checkTravelInfo(pasApisInfo);
                documents = generateDocumentsInfo(pasApisInfo, pasApisInfoTransformed.travelInfo, travelInfo);
                pasApisInfoTransformed.mandatoryDocuments = documents.mandatoryDocuments;
                pasApisInfoTransformed.optionalDocuments = documents.optionalDocuments;
                pasApisInfoTransformed.visaDocument = documents.visaDocument;
                if (!isInfant) {
                    pasApisInfoTransformed.contactData = generateContactData(pasApisInfo, pasApisInfo.emergencyContact, index);
                    viewValues = generateDestination(pasApisInfo);
                    pasApisInfoTransformed.view.showInTransit = viewValues.showInTransit;
                    pasApisInfoTransformed.view.showInTransitForAll = viewValues.showInTransitForAll;
                    pasApisInfoTransformed.view.showOptions = viewValues.showOptions;
                    pasApisInfoTransformed.frequentFlyer = generateFrequentFlyer(pasApisInfo.id);
                    pasApisInfoTransformed.inTransit = { isInTransit: pasApisInfo.inTransit };
                    pasApisInfoTransformed.destinationAddress = pasApisInfo.destinationAddress;
                    if (pasApisInfo.homeAddress) {
                        pasApisInfoTransformed.homeAddress = pasApisInfo.homeAddress;
                        pasApisInfoTransformed.homeAddress.country = pasApisInfoTransformed.homeAddress.country && pasApisInfoTransformed.homeAddress.country.code ?
                            pasApisInfoTransformed.homeAddress.country.code : null;
                    }
                    if (pasApisInfo.destinationAddress !== null) {
                        pasApisInfoTransformed.destinationAddress.address = pasApisInfo.destinationAddress.address;
                        pasApisInfoTransformed.destinationAddress.city = pasApisInfo.destinationAddress.city;
                        pasApisInfoTransformed.destinationAddress.state = getStateCode(pasApisInfo.destinationAddress.state);
                        pasApisInfoTransformed.destinationAddress.zipCode = pasApisInfo.destinationAddress.zipCode;
                        pasApisInfoTransformed.destinationAddress.country = pasApisInfoTransformed.destinationAddress.country;
                    }
                } else {
                    pasApisInfoTransformed.relatedParentId = parentInfo.id;
                }

                return pasApisInfoTransformed;

                function getStateCode (state) {
                    let stateCode = null, sIndex = 0, sFound = false;
                    let auxState = state || '';
                    while (!sFound && sIndex < statesList.length) {
                        if (auxState.toUpperCase() === statesList[sIndex].description.toUpperCase()) {
                            sFound = true;
                            stateCode = statesList[sIndex].code;
                        }
                        sIndex++;
                    }
                    return stateCode;
                }


                function getPasDate (date) {
                    let returnedDate = {}, splitedDate = [];
                    if (date) {
                        splitedDate = date.split('-');
                        returnedDate.day = splitedDate[2];
                        returnedDate.month = splitedDate[1];
                        returnedDate.year = splitedDate[0];
                    }
                    return returnedDate;
                }

                function generateDestination (passengerInfo) {
                    let view = { showOptions: false, showInTransit: false, showInTransitForAll: false }, i;
                    view.showInTransit = passengerInfo.requiredFields.indexOf(ApisFormConstants.FIELDS.DESTINATION_ADDRESS) !== -1
                        || passengerInfo.requiredFields.indexOf(ApisFormConstants.FIELDS.DESTINATION_CITY) !== -1
                        || passengerInfo.requiredFields.indexOf(ApisFormConstants.FIELDS.DESTINATION_STATE) !== -1
                        || passengerInfo.requiredFields.indexOf(ApisFormConstants.FIELDS.DESTINATION_ZIP) !== -1
                        || passengerInfo.requiredFields.indexOf(ApisFormConstants.FIELDS.DESTINATION_COUNTRY) !== -1;
                    view.showOptions = view.showInTransit;

                    return view;
                }

                /**
                 * Check if user passenger selected have card ibPlus same that logged andy
                 * @param {Object} pasInfo Information of passenger for check frequent flyer
                 * @return {Object}  status Object with values for passenger
                 */
                function checkTravelInfo (pasInfo) {
                    let i, isEnable = false, bookingInfo, loggedInfo;

                    if (UtilsService.isUserLogged()) {
                        bookingInfo = localStorageService.get('bookingInfo');
                        loggedInfo = localStorageService.get('loggedInfo');
                        for (i = 0; i < bookingInfo.passengers.length; i++) {
                            if (pasInfo.id === bookingInfo.passengers[i].id.toString()) {
                                if (bookingInfo.passengers[i].frequentFlyer && bookingInfo.passengers[i].frequentFlyer.number === loggedInfo.personalInfo.ibPlusNumber) {
                                    isEnable = true;
                                }
                            }
                        }

                    }
                    return isEnable;
                }


                function generateBasicInfo (passSecurityID, passSecurityInfo, isInfant, parentHomeCountry) {
                    const pasNames = getPasName(passSecurityID, passSecurityInfo, isInfant);
                    const basicInfo = {
                        showName: isInfant ? pasNames.booking.infant.name : pasNames.booking.name,
                        showSurname: isInfant ? pasNames.booking.infant.surname : pasNames.booking.surname,
                        name: isInfant ? pasNames.security.infant.name : pasNames.security.name,
                        surname: isInfant ? pasNames.security.infant.surname : pasNames.security.surname,
                        gender: passSecurityInfo.gender,
                        birthDate: getPasDate(passSecurityInfo.birthDate),
                        type: isInfant ? CheckinAppConstants.PASSENGERS_TYPES.INFANT : getPassengerType(passSecurityID),
                        nationality: passSecurityInfo.nationality ? passSecurityInfo.nationality.code : defaultCountry.code,
                        isInfant: isInfant || false,
                        homeCountry: !isInfant ? (passSecurityInfo.homeAddress && passSecurityInfo.homeAddress.country && passSecurityInfo.homeAddress.country.code)
                            : parentHomeCountry
                    };
                    return basicInfo;
                }


                function generateContactData (passengerInfo, emergencyContactData, index) {
                    let returnedContactData = { additionalInfo: {}, emergencyInfo: {} }, iPas = 0, pasFound = false, cachedInfo = localStorageService.get('bookingInfo');
                    returnedContactData.additionalInfo = {
                        denyNewsLetters: false,
                        prefix: defaultPrefix,
                        showUseForAll: index === 0,
                        showData: true,
                        isOptional: passengerInfo.requiredFields.indexOf(CheckinAppConstants.PASSENGER_DATA_OPTIONS.CONTACT_DATA) !== 1 && cachedInfo.passengers[index].requiredInformation.indexOf(CheckinAppConstants.PASSENGER_DATA_OPTIONS.CONTACT_DATA) !== 1
                    };
                    while (!pasFound && iPas < initialDisruptionContactData.length) {
                        if (passengerInfo.id === '' + initialDisruptionContactData[iPas].id) {
                            pasFound = true;
                            if (initialDisruptionContactData[iPas].disruptionContact) {
                                returnedContactData.additionalInfo.email = initialDisruptionContactData[iPas].disruptionContact.email;
                                returnedContactData.additionalInfo.language = initialDisruptionContactData[iPas].disruptionContact.language;
                                if (initialDisruptionContactData[iPas].disruptionContact.phone) {
                                    returnedContactData.additionalInfo.prefix = (initialDisruptionContactData[iPas].disruptionContact?.phone?.countryCode?.code) ? initialDisruptionContactData[iPas].disruptionContact.phone.countryCode.code : defaultPrefix;
                                    returnedContactData.additionalInfo.phone = initialDisruptionContactData[iPas].disruptionContact.phone.number;
                                }
                            }
                        }
                        iPas++;
                    }
                    returnedContactData.emergencyInfo = {
                        showData: true,
                        showUseForAll: index === 0,
                        prefix: defaultPrefix,
                        isOptional: checkUsTracing(passengerInfo.requiredFields, cachedInfo.passengers[index].requiredInformation),
                        isPrivacyStatement: (cachedInfo.passengers[index].requiredInformation.indexOf(CheckinAppConstants.PASSENGER_DATA_OPTIONS.PRIVACY_STATEMENT) !== -1)
                    };
                    if (emergencyContactData) {
                        returnedContactData.emergencyInfo.name = emergencyContactData.name;
                        returnedContactData.emergencyInfo.refused = emergencyContactData.refused;
                        if (emergencyContactData.phone) {
                            returnedContactData.emergencyInfo.prefix = (emergencyContactData.phone.countryCode?.code) ? emergencyContactData.phone.countryCode?.code : defaultPrefix;
                            returnedContactData.emergencyInfo.phone = emergencyContactData.phone.number;
                        }
                    }
                    return returnedContactData;
                }

                function checkUsTracing (passInfoRequiredFields, bookingInfoPassInfoRequired) {
                    let isOptional = true;
                    let requiredFields = false;
                    let requiredInfo = false;

                    requiredFields = (passInfoRequiredFields.indexOf(CheckinAppConstants.PASSENGER_DATA_OPTIONS.EMERGENCY_DATA) !== -1 || passInfoRequiredFields.indexOf(ApisFormConstants.FIELDS.EMERGENCY_CONTACT_NAME) !== -1 || passInfoRequiredFields.indexOf(ApisFormConstants.FIELDS.EMERGENCY_CONTACT_PHONE) !== -1);
                    requiredInfo = (bookingInfoPassInfoRequired.indexOf(CheckinAppConstants.PASSENGER_DATA_OPTIONS.EMERGENCY_DATA) !== -1);

                    isOptional = !(requiredInfo || requiredFields);

                    return isOptional;
                }
                function generateFrequentFlyer (pasId) {
                    let returnedFrequentFlyer = { enabled: true, info: { iataCompanyCode: apisFormTransformed.companylist[0].iataCompanyCode }, isOptional: true };
                    let cachedInfo = localStorageService.get('bookingInfo');
                    let pfound = false, pIndex = 0;
                    while (!pfound && pIndex < cachedInfo.passengers.length) {
                        if (pasId === '' + cachedInfo.passengers[pIndex].id.toString()) {
                            pfound = true;
                            if (cachedInfo.passengers[pIndex].frequentFlyer) {
                                returnedFrequentFlyer.enabled = false;
                                returnedFrequentFlyer.info.iataCompanyCode = cachedInfo.passengers[pIndex].frequentFlyer.iataCompanyCode;
                                returnedFrequentFlyer.info.number = cachedInfo.passengers[pIndex].frequentFlyer.number;
                            }
                            returnedFrequentFlyer.isOptional = !cachedInfo.passengers[pIndex].requiredInformation.indexOf(CheckinAppConstants.PASSENGER_DATA_OPTIONS.FREQUENT_FLYER) !== -1;
                        }
                        pIndex++;
                    }
                    return returnedFrequentFlyer;
                }

                function generateDocumentsInfo (passengerInfo, isTravelInfo, documentsTravelInfo) {
                    let returnedDocuments = { mandatoryDocuments: {}, optionalDocuments: {}, visaDocument: null }, auxDocuments = {}, i, k, isDocSelected;

                    returnedDocuments.mandatoryDocuments.nationality = passengerInfo.nationality ? passengerInfo.nationality.code : defaultCountry.code;
                    returnedDocuments.mandatoryDocuments.isMandatory = true;
                    returnedDocuments.mandatoryDocuments.documents = [];
                    passengerInfo.mandatoryDocuments = passengerInfo.mandatoryDocuments || [];
                    for (i = 0; i < passengerInfo.mandatoryDocuments.length; i++) {
                        for (k = 0; k < passengerInfo.mandatoryDocuments[i].documents.length; k++) {
                            if (passengerInfo.mandatoryDocuments[i].documents[k].type.code !== ApisFormConstants.DOCUMENT_TYPES.VISA) {
                                if (!auxDocuments[passengerInfo.mandatoryDocuments[i].documents[k].type.code]) {
                                    checkDocumentIssuerCountry(passengerInfo.mandatoryDocuments[i].documents[k], returnedDocuments.mandatoryDocuments.nationality);
                                    auxDocuments[passengerInfo.mandatoryDocuments[i].documents[k].type.code] = passengerInfo.mandatoryDocuments[i].documents[k];
                                    getDocumentValues(passengerInfo.mandatoryDocuments[i].documents[k], false);
                                    returnedDocuments.mandatoryDocuments.documents.push(passengerInfo.mandatoryDocuments[i].documents[k]);
                                }
                            } else {
                                returnedDocuments.visaDocument = { isMandatory: true };
                                angular.extend(returnedDocuments.visaDocument, passengerInfo.mandatoryDocuments[i].documents[k]);
                                getDocumentValues(returnedDocuments.visaDocument, false);
                            }
                        }
                    }
                    if (isTravelInfo) getTravelDocuments(returnedDocuments.mandatoryDocuments.documents, documentsTravelInfo);

                    returnedDocuments.optionalDocuments.nationality = passengerInfo.nationality ? passengerInfo.nationality.code : defaultCountry.code;
                    returnedDocuments.optionalDocuments.isMandatory = false;
                    returnedDocuments.optionalDocuments.documents = [];
                    passengerInfo.optionalDocuments = passengerInfo.optionalDocuments || [];
                    for (i = 0; i < passengerInfo.optionalDocuments.length; i++) {
                        if (passengerInfo.optionalDocuments[i].type.code !== ApisFormConstants.DOCUMENT_TYPES.VISA) {
                            checkDocumentIssuerCountry(passengerInfo.optionalDocuments[i], returnedDocuments.optionalDocuments.nationality);
                            getDocumentValues(passengerInfo.optionalDocuments[i], true);
                            returnedDocuments.optionalDocuments.documents.push(passengerInfo.optionalDocuments[i]);
                        } else {
                            returnedDocuments.visaDocument = returnedDocuments.visaDocument || { isMandatory: false };
                            angular.extend(returnedDocuments.visaDocument, passengerInfo.optionalDocuments[i]);
                            if (!returnedDocuments.visaDocument.isMandatory) getDocumentValues(returnedDocuments.visaDocument, false);
                        }

                    }
                    if (returnedDocuments.mandatoryDocuments.documents.length === 1) {
                        returnedDocuments.mandatoryDocuments.selectedDoc = returnedDocuments.mandatoryDocuments.documents[0];
                    }
                    if (returnedDocuments.optionalDocuments.documents.length > 0) {
                        returnedDocuments.optionalDocuments.documents.unshift({ type: { description: $filter('translate')('CKI_COMBO_BLANK'), code: 'CKI_COMBO_BLANK' } });
                    }
                    return returnedDocuments;

                    function getDocumentValues (currentDocument, isOptionalDocumentSection) {
                        let i = 0, docFound = false;
                        while (!docFound && i < passengerInfo.documents.length) {
                            if (currentDocument.type.code === passengerInfo.documents[i].type?.code) {
                                docFound = true;
                                currentDocument.number = passengerInfo.documents[i].number || '';
                                currentDocument.issuedDate = getPasDate(passengerInfo.documents[i].issuedDate) || null;
                                currentDocument.expiryDate = getPasDate(passengerInfo.documents[i].expiryDate);
                                currentDocument.issuerCountry = passengerInfo.documents[i].issuerCountry ? passengerInfo.documents[i].issuerCountry.code : (currentDocument.issuerCountry || defaultCountry.code);
                                currentDocument.saveDocument = false;
                                if (!isDocSelected && isOptionalDocumentSection) {
                                    returnedDocuments.optionalDocuments.selectedDoc = currentDocument;
                                    isDocSelected = true;
                                }
                            }
                            i++;
                        }
                        currentDocument.isSaved = false;

                    }

                    /**
                     * Add travel document to passenger if passenger logged is same
                     * @param {Array} passengerDocuments Documents of passenger
                     * @param {Object} travelInfo Travel info of service
                     */
                    function getTravelDocuments (passengerDocuments, travelInfo) {
                        let loggedInfo, newDocument = {}, isAdded = false, i, k, j;
                        loggedInfo = localStorageService.get('loggedInfo');

                        if (loggedInfo.personalInfo.ibPlusNumber === travelInfo.ibPlusNumber) {
                            for (i = 0; i < travelInfo.documents.length; i++) {
                                newDocument = travelInfo.documents[i];
                                newDocument.type.description = newDocument.type.description + ' ' + newDocument.issuerCountry.description;
                                newDocument.expiryDate = getPasDate(newDocument.expiryDate);
                                newDocument.issuedDate = getPasDate(newDocument.issuedDate);
                                newDocument.isSaved = true;
                                if (checkDocument(travelInfo.documents[i].type.code)) {
                                    passengerDocuments.push(newDocument);
                                    if (!isAdded) {
                                        for (j = 0; j < passengerDocuments.length; j++) {
                                            if (!passengerDocuments[j].isSaved) {
                                                passengerDocuments[j].type.description = $filter('translate')('APIS_DOCUMENT_LABEL_NEW') + ' ' + passengerDocuments[j].type.description;
                                            }
                                        }
                                        isAdded = true;
                                    }
                                }
                            }
                        }

                        function checkDocument (typeDocument) {
                            let k = 0, dFound = false;
                            while (!dFound && k < passengerDocuments.length) {
                                dFound = passengerDocuments[k].type.code === typeDocument;
                                k++;
                            }
                            return dFound;
                        }
                    }

                    function checkDocumentIssuerCountry (currentDocument, nationality) {
                        if (currentDocument.type.code === ApisFormConstants.DOCUMENT_TYPES.DNI &&
                            currentDocument.requiredFields.indexOf(ApisFormConstants.DOCUMENT_FIELDS.CNTRY_DOC) !== -1) {
                            currentDocument.issuerCountry = nationality;
                        } else if ((currentDocument.type.code === ApisFormConstants.DOCUMENT_TYPES.GREENCARD || currentDocument.type.code === ApisFormConstants.DOCUMENT_TYPES.REDRESSNUMBER
                            || currentDocument.type.code === ApisFormConstants.DOCUMENT_TYPES.KNOWNTRAVELERNUMBER) && currentDocument.requiredFields.indexOf(ApisFormConstants.DOCUMENT_FIELDS.CNTRY_DOC) !== -1) {
                            currentDocument.issuerCountry = ApisFormConstants.USA_NATIONALITY;
                        }
                    }
                }
            }

            function getPasName (passengerId, passSecurityInfo, isInfant) {
                const bookingInfo = localStorageService.get('bookingInfo');
                const namesInfo = {
                    security: {
                        name: '',
                        surname: '',
                        infant: {
                            name: '',
                            surname: ''
                        }
                    },
                    booking: {
                        name: '',
                        surname: '',
                        infant: {
                            name: '',
                            surname: ''
                        }
                    }
                };

                if (isInfant) {
                    namesInfo.security.infant.name = passSecurityInfo.name || '';
                    namesInfo.security.infant.surname = passSecurityInfo.surname || '';
                } else {
                    namesInfo.security.name = passSecurityInfo.name || '';
                    namesInfo.security.surname = passSecurityInfo.surname || '';
                }

                bookingInfo.passengers.forEach(passenger => {
                    if (passengerId === passenger.id.toString()) {
                        if (isInfant) {
                            namesInfo.booking.infant.name = passenger.infant.name || '';
                            namesInfo.booking.infant.surname = passenger.infant.surname || '';
                        } else {
                            namesInfo.booking.name = passenger.name || '';
                            namesInfo.booking.surname = passenger.surname || '';
                        }
                    }
                });
                return namesInfo;
            }

            function getPassengerType (passengerId) {
                let cachedInfo = localStorageService.get('bookingInfo');
                let pasType = CheckinAppConstants.PASSENGERS_TYPES.ADULT, pfound = false, pIndex = 0;
                while (!pfound && pIndex < cachedInfo.passengers.length) {
                    if (passengerId === '' + cachedInfo.passengers[pIndex].id) {
                        pasType = cachedInfo.passengers[pIndex].type;
                    }
                    pIndex++;
                }
                return pasType;
            }
        }


        /**
         * Return the state of the passenger
         * @param {Object} passenger Passenger information of security service
         * @param {Object} cachedInfo Information of service cached
         * @return null
         */
        function checkStatusPassenger (passenger, cachedInfo) {
            let i, status = { code: '', reason: null };
            let existReasonMsg = false;
            for (i = 0; i < cachedInfo.passengers.length; i++) {
                if (passenger.id === cachedInfo.passengers[i].id.toString()) {
                    status = cachedInfo.passengers[i].status;
                    existReasonMsg = (angular.isObject(passenger.status) && angular.isObject(passenger.status.reason) && angular.isString(passenger.status.reason.message));
                    if (status.code === ApisFormConstants.PASSENGER_STATUS.NOT_ALLOWED && existReasonMsg) {
                        status.reason = passenger.status.reason.message;
                    }
                }
                existReasonMsg = false;
            }
            return status;
        }


        function generateCustomerTravelInfo (passengers) {
            let i, requestPassenger = { name: null, surname: null, gender: null, birthDate: null, nationality: { code: null }, documents: null };

            for (i = 0; i < passengers.length; i++) {
                if (passengers[i].travelInfo) {
                    requestPassenger.name = passengers[i].basicInfo.name;
                    requestPassenger.surname = passengers[i].basicInfo.surname;
                    requestPassenger.gender = passengers[i].basicInfo.gender;
                    requestPassenger.birthDate = passengers[i].basicInfo.birthDate.year + '-' + passengers[i].basicInfo.birthDate.month + '-' + passengers[i].basicInfo.birthDate.day;
                    requestPassenger.nationality.code = passengers[i].basicInfo.nationality;
                    requestPassenger.documents = getSavedDocuments(passengers[i].mandatoryDocuments.documents);
                }

            }

            return requestPassenger;

            function getSavedDocuments (documents) {
                let arrayDocuments = [], documentSaved, k;
                for (k = 0; k < documents.length; k++) {
                    documentSaved = {
                        type: { code: null }, number: null, issuerCountry: { code: null }
                    };
                    if (documents[k].saveDocument) {
                        documentSaved.type.code = documents[k].type.code;
                        if (documents[k].expiryDate) documentSaved.expiryDate = documents[k].expiryDate.year + '-' + documents[k].expiryDate.month + '-' + documents[k].expiryDate.day;
                        if (documents[k].issuedDate) documentSaved.issuedDate = documents[k].issuedDate.year + '-' + documents[k].issuedDate.month + '-' + documents[k].issuedDate.day;
                        documentSaved.number = documents[k].number;
                        documentSaved.issuerCountry.code = documents[k].issuerCountry;
                        arrayDocuments.push(documentSaved);
                    }
                }
                return arrayDocuments;
            }
        }


        /**
         * Update the status of passenger returned for the cached service
         * @param {Array} passengers Model of passengers
         * @param {Array} updatePassengers Response of service with updated passengers
         * @return null
         */
        function updateStatusPassenger (passengers, updatePassengers, model) {
            let i, k;

            for (i = 0; i < updatePassengers.length; i++) {
                for (k = 0; k < passengers.length; k++) {
                    if (passengers[k].id === updatePassengers[i].id.toString()) {
                        if (updatePassengers[i].status.code === ApisFormConstants.PASSENGER_STATUS.NOT_ALLOWED) {
                            passengers[k].status.code = ApisFormConstants.PASSENGER_STATUS.NOT_ALLOWED;
                            passengers[k].status.reason = updatePassengers[i].status.reason.message;
                            passengers[k].boardingCard = false;

                        }
                    }
                }
            }
            updatePassengersDataContact(passengers, 0, ApisFormConstants.TYPE_DATA_FORM.UPDATE_SHOW_FOR_ALL, false, model);
        }


        function generatePassengerPendingAQQ (cachedInfo, apisPassenger) {
            let selectedSegments = localStorageService.get('availableSegments') || [];
            let pasPending = [];
            apisPassenger = apisPassenger || [];
            pasPending = generateCheckSegments(cachedInfo.outwardSegments || [], apisPassenger, selectedSegments, pasPending);
            return generateCheckSegments(cachedInfo.returnSegments || [], apisPassenger, selectedSegments, pasPending);

            function generateCheckSegments (segments, passengers, segmentsSelected, pasPendingAQQ) {
                let i = 0, j = 0;
                for (i = 0; i < segments.length; i++) {
                    if (segmentsSelected.indexOf(segments[i].id) !== -1) {
                        for (j = 0; j < segments[i].passengers.length; j++) {
                            if (passengers.indexOf(segments[i].passengers[j].id) !== -1
                                && (segments[i].passengers[j].status.code === 'PENDING_AQQ' || segments[i].passengers[j].status.code === 'PENDING_EVUS')
                                && pasPendingAQQ.indexOf(segments[i].passengers[j].id) === -1) {
                                pasPendingAQQ.push(segments[i].passengers[j].id);
                            }
                        }
                    }
                }
                return pasPendingAQQ;
            }
        }

        function checkUpdatedPassengersStatus () {
            let selectedSegments = localStorageService.get('availableSegments');
            let cachedInfo = localStorageService.get('bookingInfo');
            let updatedPassengers = localStorageService.get('passengersAPISUpdated');
            let apisPendingAQQ = localStorageService.get('apisPendingAQQ');
            let outwardSegmentsInfo = checkSegments(cachedInfo.outwardSegments || [], apisPendingAQQ, selectedSegments, updatedPassengers);
            let returnedSegmentsInfo = checkSegments(cachedInfo.returnSegments || [], apisPendingAQQ, selectedSegments, updatedPassengers, outwardSegmentsInfo.pendingPas);
            return { pendingPas: returnedSegmentsInfo.pendingPas, isUncheckable: outwardSegmentsInfo.isUncheckable || returnedSegmentsInfo.isUncheckable };

            function checkSegments (segments, passengersPending, segmentsSelected, pasUpdated, currentPendingPas) {
                let segmentsChecked = { pendingPas: currentPendingPas || [], isUncheckable: false };
                let i, j = 0;
                for (i = 0; i < segments.length; i++) {
                    if (segmentsSelected.indexOf(segments[i].id) !== -1) {
                        for (j = 0; j < segments[i].passengers.length; j++) {
                            if (passengersPending.indexOf(segments[i].passengers[j].id) !== -1 && pasUpdated.indexOf(segments[i].passengers[j].id) !== -1) {
                                if (!segmentsChecked.isUncheckable && segments[i].passengers[j].status.code === 'UNCHECKABLE') {
                                    segmentsChecked.isUncheckable = true;
                                } else if ((segments[i].passengers[j].status.code === 'PENDING_AQQ' || segments[i].passengers[j].status.code === 'PENDING_EVUS')
                                    && segmentsChecked.pendingPas.indexOf(segments[i].passengers[j].id) === -1) {
                                    segmentsChecked.pendingPas.push(segments[i].passengers[j].id);
                                }
                            }
                        }
                    }
                }
                return segmentsChecked;
            }
        }

        /**
         * Build strcuture for send to service for update apis
         * @param {Object} apisModel
         */
        function generateUpdateApisRequest (model) {
            let i, apisModel = {}, passArray = [], isCopyDestinationAdress = false, copyDestinationAdress = null;
            angular.copy(model.apisPassengerInfo, apisModel);


            for (i = 0; i < apisModel.passengers.length; i++) {
                if (i < apisModel.passengers.length - 1 && apisModel.passengers[i + 1].basicInfo.isInfant
                    && apisModel.passengers[i + 1].relatedParentId === apisModel.passengers[i].id) {
                    //adds infant to current ADULT passenger and removes it from passengers array
                    apisModel.passengers[i].infantInfo = apisModel.passengers[i + 1];
                    apisModel.passengers.splice(i + 1, 1);
                }
                if (apisModel.passengers[i].boardingCard) passArray.push(generatePassengerRequest(apisModel.passengers[i], model.showData));
            }
            if (model.showData.useEmergencyForAll && passArray.length > 1) {
                updateEmergencyForAll(passArray);
            }
            return passArray;

            /**
              * Copy emergency information for first passenger to other passenger when option
              * useEmergencyForAll is true
              * @param {Array} passengers List of passengers for send to service
              */
            function updateEmergencyForAll (passengers) {
                let i, isFound = false, emergencyContact;
                for (i = 0; i < passengers.length; i++) {
                    if (!isFound) {
                        emergencyContact = passengers[i].emergencyContact;
                        isFound = true;
                    } else {
                        passengers[i].emergencyContact = emergencyContact;
                    }
                }
            }

            function generatePassengerRequest (currentPas, showData) {
                let apisRequest = {}, k;
                if (!currentPas.contactData.emergencyInfo.isOptional || ((currentPas.contactData.emergencyInfo.name && currentPas.contactData.emergencyInfo.name !== '') && (currentPas.contactData.emergencyInfo.phone && currentPas.contactData.emergencyInfo.phone !== ''))) {
                    apisRequest.emergencyContact = {
                        refused: false
                    };
                    if (currentPas.contactData.emergencyInfo.name && currentPas.contactData.emergencyInfo.name !== '') {
                        apisRequest.emergencyContact.name = currentPas.contactData.emergencyInfo.name;
                    }
                    if (currentPas.contactData.emergencyInfo.phone && currentPas.contactData.emergencyInfo.phone !== '') {
                        const prefix = getPrefix(currentPas.contactData.emergencyInfo.prefix);

                        apisRequest.emergencyContact.phone = {
                            countryCode: currentPas.contactData.emergencyInfo.prefix,
                            number: currentPas.contactData.emergencyInfo.phone
                        };

                    }
                }


                if (isCopyDestinationAdress && copyDestinationAdress) {
                    if (currentPas.boardingCard && currentPas.view.showInTransit) {
                        if (currentPas.inTransit.isInTransit) {
                            apisRequest.inTransit = currentPas.inTransit.isInTransit;
                        } else {
                            apisRequest.inTransit = currentPas.inTransit.isInTransit;
                            apisRequest.destinationAddress = copyDestinationAdress;
                        }
                    }
                }

                if (currentPas.view.showInTransit && currentPas.view.showInTransitForAll && showData.useInTransitForAll && !isCopyDestinationAdress) {
                    if (currentPas.inTransit.isInTransit) {
                        apisRequest.inTransit = currentPas.inTransit.isInTransit;
                    } else {
                        apisRequest.destinationAddress = currentPas.destinationAddress;
                        apisRequest.inTransit = currentPas.inTransit.isInTransit;
                        copyDestinationAdress = currentPas.destinationAddress;
                        isCopyDestinationAdress = true;
                    }
                }

                if (!isCopyDestinationAdress) {
                    if (currentPas.view.showInTransit) {
                        if (!currentPas.inTransit.isInTransit) {
                            apisRequest.destinationAddress = currentPas.destinationAddress;
                        }
                        apisRequest.inTransit = currentPas.inTransit.isInTransit;
                    }
                }

                if (currentPas.requiredFields.indexOf(ApisFormConstants.FIELDS.DESTINATION_COUNTRY) !== -1) {
                    angular.extend(currentPas.destinationAddress || {}, { country: ApisFormConstants.USA_NATIONALITY });
                }

                if ((currentPas.requiredFields.indexOf(ApisFormConstants.FIELDS.HOME_COUNTRY) !== -1) && (currentPas.requiredFields.indexOf(ApisFormConstants.FIELDS.HOME_ADDRESS) === -1)) {
                    apisRequest.homeAddress = angular.extend(currentPas.homeAddress || {}, { country: currentPas.basicInfo.homeCountry });
                }

                if (currentPas.requiredFields.indexOf(ApisFormConstants.FIELDS.HOME_ADDRESS) !== -1) {
                    apisRequest.homeAddress = angular.extend(currentPas.homeAddress || {});
                }

                angular.extend(apisRequest, generateCommonPasInfo(currentPas));
                if (currentPas.infantInfo) {
                    apisRequest.infantPassengerSecurityInformation = generateInfantRequest(currentPas.infantInfo);
                }
                return apisRequest;
            }

            function removeNullAttr (currentObject) {
                let obj;
                for (obj in currentObject) {
                    if (currentObject[obj] === null) {
                        delete currentObject[obj];
                    }
                }
            }

            function generateCommonPasInfo (pasInfo) {
                let returnedPasInfo = {
                    id: pasInfo.id || '',
                    name: pasInfo.basicInfo.name,
                    surname: pasInfo.basicInfo.surname,
                    gender: pasInfo.basicInfo.gender,
                    birthDate: pasInfo.basicInfo.birthDate.year + '-' + pasInfo.basicInfo.birthDate.month + '-' + pasInfo.basicInfo.birthDate.day,
                    nationality: pasInfo.basicInfo.nationality
                };
                if (pasInfo.title) returnedPasInfo.title = pasInfo.title;
                returnedPasInfo.documents = generateDocumentsRequest(pasInfo.mandatoryDocuments.selectedDoc)
                    .concat(generateDocumentsRequest(pasInfo.visaDocument)
                        .concat(generateDocumentsRequest(pasInfo.optionalDocuments.selectedDoc)));
                return returnedPasInfo;
            }

            function generateDocumentsRequest (doc) {
                let returnedDocuments = [], aux, i;
                if (doc && doc.type && doc.type.code === ApisFormConstants.DOCUMENT_TYPES.VISA) {
                    aux = getDocumentInfo(doc);
                    if (aux) returnedDocuments.push(aux);
                } else {
                    if (doc && doc.type.code !== 'CKI_COMBO_BLANK') {
                        aux = getDocumentInfo(doc);
                        if (aux) returnedDocuments.push(aux);
                    }
                }


                return returnedDocuments;

                function getDocumentInfo (doc) {
                    let auxDoc = null, rIndex = 0, rfound = false;
                    if (doc.isSaved) {
                        auxDoc = angular.extend(auxDoc || {}, { type: doc.type.code, number: doc.number });
                        auxDoc = angular.extend(auxDoc || {}, { type: doc.type.code, issuerCountry: doc.issuerCountry.code });

                        auxDoc = angular.extend(auxDoc || {}, { type: doc.type.code, expiryDate: doc.expiryDate.year + '-' + doc.expiryDate.month + '-' + doc.expiryDate.day });
                        auxDoc = angular.extend(auxDoc || {}, { type: doc.type.code, issuedDate: doc.issuedDate.year + '-' + doc.issuedDate.month + '-' + doc.issuedDate.day });
                    } else {
                        while (!rfound && rIndex < doc.requiredFields.length) {
                            if (doc.requiredFields[rIndex] === ApisFormConstants.DOCUMENT_FIELDS.NUM_DOC) {
                                if (doc.number) {
                                    auxDoc = angular.extend(auxDoc || {}, { type: doc.type.code, number: doc.number });
                                } else {
                                    rfound = true;
                                }
                            }
                            if (doc.requiredFields[rIndex] === ApisFormConstants.DOCUMENT_FIELDS.CNTRY_DOC || doc.isSaved) {
                                if (doc.issuerCountry) {
                                    auxDoc = angular.extend(auxDoc || {}, { type: doc.type.code, issuerCountry: doc.issuerCountry });
                                } else {
                                    rfound = true;
                                }
                            }
                            if (doc.requiredFields[rIndex] === ApisFormConstants.DOCUMENT_FIELDS.EXPIRY_DOC || doc.isSaved) {
                                if (doc.expiryDate && doc.expiryDate.year && doc.expiryDate.month && doc.expiryDate.day) {
                                    auxDoc = angular.extend(auxDoc || {}, { type: doc.type.code, expiryDate: doc.expiryDate.year + '-' + doc.expiryDate.month + '-' + doc.expiryDate.day });
                                } else {
                                    rfound = true;
                                }
                            }
                            if (doc.requiredFields[rIndex] === ApisFormConstants.DOCUMENT_FIELDS.ISSUE_DOC || doc.isSaved) {
                                if (doc.issuedDate && doc.issuedDate.year && doc.issuedDate.month && doc.issuedDate.day) {
                                    auxDoc = angular.extend(auxDoc || {}, { type: doc.type.code, issuedDate: doc.issuedDate.year + '-' + doc.issuedDate.month + '-' + doc.issuedDate.day });
                                } else {
                                    rfound = true;
                                }
                            }
                            rIndex++;
                        }
                    }

                    if (rfound) auxDoc = null;
                    return auxDoc;
                }
            }

            function generateInfantRequest (infantInfo) {
                return generateCommonPasInfo(infantInfo);
            }

            function getPrefix (code) {
                const phoneCodeList = localStorageService.get('phoneCodeList');
                const market = {
                    countryCode: UtilsService.getAppMarket() || 'ES',
                    code: ''
                };
                let prefix = {
                    countryCode: '',
                    code: code ? code : ''
                };
                if(Array.isArray(phoneCodeList)) {
                    phoneCodeList.forEach(element => {
                        if (element.code === prefix.code) {
                            prefix.countryCode = element.countryCode;
                        }

                        if (market.countryCode.toUpperCase() === element.countryCode) {
                            market.code = element.code;
                        }
                    });

                    if(prefix.code === '' && prefix.countryCode === '' && market.code !== '' && market.countryCode !== '') {
                        prefix = market;
                    }
                }

                return prefix;
            }
        }


        function generateAdditionalInformationRequest (apisModel) {
            const bookingInfo = localStorageService.get('bookingInfo');
            let i, addInfoRequestArray = [], isCopied = false, passengerContactData = [];
            for (i = 0; i < apisModel.apisPassengerInfo.passengers.length; i++) {
                if (!apisModel.apisPassengerInfo.passengers[i].basicInfo.isInfant && apisModel.apisPassengerInfo.passengers[i].boardingCard) {
                    addInfoRequestArray.push(getPassengerAdditionalRequest(apisModel.apisPassengerInfo.passengers[i], apisModel));
                }
            }
            localStorageService.set('passengersContactData', passengerContactData);
            return addInfoRequestArray;

            function getPassengerAdditionalRequest (currentPas, apisModel) {
                const isFreeType = angular.isDefined(bookingInfo?.outwardSegments[0]?.passengers[0]?.freeType);
                const addInfoRequest = {
                    id: currentPas.id,
                    gender: currentPas.basicInfo.gender
                };

                const contactData = { id: null, email: null, phone: null };

                if (!currentPas.contactData.additionalInfo.isOptional || ((currentPas.contactData.additionalInfo.email && currentPas.contactData.additionalInfo.email !== '') && (currentPas.contactData.additionalInfo.phone && currentPas.contactData.additionalInfo.phone !== ''))) {
                    addInfoRequest.disruptionContact = getDisruption(currentPas, apisModel);
                }
                updateAdditionalInfo(currentPas.id, addInfoRequest.disruptionContact);
                if (currentPas.frequentFlyer.info.number && currentPas.frequentFlyer.enabled && !isFreeType) {
                    addInfoRequest.frequentFlyer = {
                        iataCompanyCode: currentPas.frequentFlyer.info.iataCompanyCode,
                        number: currentPas.frequentFlyer.info.number
                    };
                }

                contactData.id = currentPas.id;
                contactData.email = currentPas.contactData.additionalInfo.email;
                contactData.phone = currentPas.contactData.additionalInfo.phone;
                passengerContactData.push(contactData);
                return addInfoRequest;
            }

            function getDisruption (currentPas, apisModel) {
                const confirmationDigitalInfo = localStorageService.get('confirmationDigitalInfo');
                let disruptionContact = {
                    language: confirmationDigitalInfo.Language,
                    email: currentPas.contactData.additionalInfo.email,
                    phone: {
                        countryCode: currentPas.contactData.additionalInfo.prefix,
                        number: currentPas.contactData.additionalInfo.phone
                    }
                };

                if (apisModel.showData.useAdditionalForAll && !isCopied) {
                    isCopied = true;
                } else if (apisModel.showData.useAdditionalForAll && isCopied && Array.isArray(addInfoRequestArray) && addInfoRequestArray.length > 0 && addInfoRequestArray[0].disruptionContact) {
                    addInfoRequestArray[0].disruptionContact.language = confirmationDigitalInfo.Language;
                    disruptionContact = addInfoRequestArray[0].disruptionContact;
                }

                return disruptionContact;
            }


            function updateAdditionalInfo (pasId, disruptionContact) {
                let currentDisruptionContactData = localStorageService.get('disruptionContactApis');
                let pfound = false, pIndex = 0;
                while (!pfound && pIndex < currentDisruptionContactData.length) {
                    if (pasId === '' + currentDisruptionContactData[pIndex].id) {
                        pfound = true;
                        currentDisruptionContactData[pIndex].disruptionContact = angular.copy(disruptionContact);
                    }
                    pIndex++;
                }
                localStorageService.set('disruptionContactApis', currentDisruptionContactData);
            }
        }

        function generateNewsLetterInfo (apisModel) {
            let currentPas = apisModel.apisPassengerInfo.passengers[apisModel.apisPassengerInfo.currentPassenger];
            let newsLettersInfo, cachedInfo;

            cachedInfo = localStorageService.get('bookingInfo');
            cachedInfo = cachedInfo.outwardSegments && cachedInfo.outwardSegments.length > 0 ? cachedInfo.outwardSegments : cachedInfo.returnSegments;
            newsLettersInfo = {
                email: currentPas.contactData.additionalInfo.email,
                name: currentPas.basicInfo.name + ' ' + currentPas.basicInfo.surname,
                departureCity: cachedInfo[0].departure.airport.code,
                destinationCity: cachedInfo[0].arrival.airport.code,
                language: CheckinAppConstants.lang,
                country: currentPas.basicInfo.homeCountry,
                unsubscribe: currentPas.contactData.additionalInfo.denyNewsLetters
            };
            if (currentPas.basicInfo.birthDate && currentPas.basicInfo.birthDate.year && currentPas.basicInfo.birthDate.month && currentPas.basicInfo.birthDate.day) {
                newsLettersInfo.birthDate = currentPas.basicInfo.birthDate.year + '-' + currentPas.basicInfo.birthDate.month + '-' + currentPas.basicInfo.birthDate.day;
            }

            return newsLettersInfo;
        }

        /**
         * Copy destination information  to other passenger from passengers selected
         * @param {Object} Passenger
         * @param {BOOL} showInTransitForAll
         * @param {Int} index
         */
        function updateDestinationPassengers (passengers, showInTransitForAll, index) {
            let i, stateInTransit;

            for (i = 0; i < passengers.length; i++) {
                if (!passengers[i].basicInfo.isInfant) {
                    if (i.toString() !== index) {
                        passengers[i].view.showOptions = showInTransitForAll;
                        passengers[i].inTransit.isInTransit = stateInTransit;
                    } else {
                        stateInTransit = passengers[i].inTransit.isInTransit;
                    }
                }
            }
        }

        /**
         * Copy origin information to other passenger from passengers selected
         * @param {Object} Passenger
         * @param {Int} index
         */
        function updateOriginPassengers (passengers, index) {
            if(Array.isArray(passengers) && passengers[index]?.homeAddress) {
                const homeAddress = passengers[index]?.homeAddress;
                for (let i = 0; i < passengers.length; i++) {
                    if (!passengers[i]?.basicInfo?.isInfant) {
                        if (i.toString() !== index) {
                            passengers[i].homeAddress = homeAddress;
                        }
                    }
                }
            }
        }


        /**
         * Delete document of passenger  selected for user in form
         * @param {Object} document Doc for delete in user
         */
        function getDocument (doc) {
            let request = { type: doc.type.code, issuerCountry: doc.issuerCountry.code };
            return request;
        }

        /**
         * Delete document selected in form of passenger
         * @param {*} doc
         * @param {*} passengers
         */
        function updateDocument (doc, passengers) {
            let i, k;
            for (i = 0; i < passengers.length; i++) {
                if (passengers[i].travelInfo) {
                    for (k = 0; k < passengers[i].mandatoryDocuments.documents.length; k++) {
                        if (passengers[i].mandatoryDocuments.documents[k].isSaved && doc.type.code === passengers[i].mandatoryDocuments.documents[k].type.code && doc.issuerCountry.code === passengers[i].mandatoryDocuments.documents[k].issuerCountry.code) {
                            passengers[i].mandatoryDocuments.documents.splice(k, 1);
                        }
                    }
                }
            }
        }


        /**
         * Update state of passenger for hidden in the form of data contact and show/hidden the
         * @param {Int} passengerId Id of passenger selected in the form of data contact
         * @param {String} type Type of option selected in the form
         * @param {BOOL} showData
         * @param {BOOL} Model
         */
        function updatePassengersDataContact (passengersData, passengerId, type, showData, model) {
            let i, newValue;

            switch (type) {
                    case ApisFormConstants.TYPE_DATA_FORM.ADDITIONAL_INFO:
                        updateAdditionalInfo(passengersData, passengerId);
                        break;

                    case ApisFormConstants.TYPE_DATA_FORM.EMERGENCY_INFO:
                        updateEmergencyInfo(passengersData, passengerId);
                        break;

                    case ApisFormConstants.TYPE_DATA_FORM.UPDATE_SHOW_FOR_ALL:
                        updateShowForAll(passengersData, showData, model);
                        break;

            }

            function updateAdditionalInfo (passengersData, passengerId) {
                for (i = 0; i < passengersData.length; i++) {
                    if (!passengersData[i].basicInfo.isInfant) {
                        newValue = !passengersData[i].contactData.additionalInfo.showData;
                        if (passengersData[i].id !== passengerId) {
                            passengersData[i].contactData.additionalInfo.showData = newValue;
                        }
                    }
                }
            }

            function updateEmergencyInfo (passengersData, passengerId) {
                for (i = 0; i < passengersData.length; i++) {
                    if (!passengersData[i].basicInfo.isInfant) {
                        newValue = !passengersData[i].contactData.emergencyInfo.showData;
                        if (passengersData[i].id !== passengerId) {
                            passengersData[i].contactData.emergencyInfo.showData = newValue;
                        }
                    }
                }
            }

            function updateShowForAll (passengersData, showData, model) {
                let counterPassengers = [], counterPass, k, isFounded = false;
                for (i = 0; i < passengersData.length; i++) {
                    if (!passengersData[i].basicInfo.isInfant) {
                        if (passengersData[i].boardingCard) {
                            counterPass = { index: i };
                            counterPassengers.push(counterPass);
                        }
                    }
                }
                if (counterPassengers.length > 1) {
                    for (k = 0; k < counterPassengers.length; k++) {
                        if (!isFounded) {
                            passengersData[counterPassengers[k].index].contactData.additionalInfo.showUseForAll = true;
                            passengersData[counterPassengers[k].index].contactData.emergencyInfo.showUseForAll = true;
                            if (passengersData[counterPassengers[k].index].view.showInTransit) {
                                passengersData[counterPassengers[k].index].view.showOptions = true;
                                passengersData[counterPassengers[k].index].view.showInTransitForAll = true;
                            }
                            isFounded = true;
                        } else {
                            passengersData[counterPassengers[k].index].contactData.additionalInfo.showUseForAll = false;
                            passengersData[counterPassengers[k].index].contactData.emergencyInfo.showUseForAll = false;
                            passengersData[counterPassengers[k].index].contactData.additionalInfo.showData = !model.useAdditionalForAll;
                            passengersData[counterPassengers[k].index].contactData.emergencyInfo.showData = !model.useEmergencyForAll;
                            if (passengersData[counterPassengers[k].index].view.showInTransit) {
                                passengersData[counterPassengers[k].index].view.showOptions = passengersData[counterPassengers[0].index].basicInfo.nationality !== ApisFormConstants.USA_NATIONALITY ? !model.useInTransitForAll : true;
                                passengersData[counterPassengers[k].index].view.showInTransitForAll = false;
                            }

                        }

                        if (showData && k !== 0) {
                            passengersData[counterPassengers[k].index].contactData.additionalInfo.showData = false;
                            passengersData[counterPassengers[k].index].contactData.emergencyInfo.showData = false;
                        }

                    }
                } else {
                    for (k = 0; k < passengersData.length; k++) {
                        if (!passengersData[k].basicInfo.isInfant) {
                            passengersData[counterPassengers[0].index].contactData.additionalInfo.showData = true;
                            passengersData[counterPassengers[0].index].contactData.emergencyInfo.showData = true;

                            if (passengersData[counterPassengers[0].index].view.showInTransit) {
                                passengersData[counterPassengers[0].index].view.showOptions = true;
                                passengersData[counterPassengers[0].index].view.showInTransitForAll = false;
                            }
                            passengersData[k].contactData.additionalInfo.showUseForAll = false;
                            passengersData[k].contactData.emergencyInfo.showUseForAll = false;
                        }
                    }
                }
            }

        }

        /**
         * Generate list of error of passengers received of service
         * @param {Array} List of passengers
         * @param {Array} errors  List of errors recived of service
         */
        function generateListErrorPassengers (passengers, errors) {
            let i, k, j = 0, isFound = false;
            cleanDataError(passengers);
            for (i = 0; i < passengers.length; i++) {
                for (k = 0; k < errors.length; k++) {
                    if (passengers[i].id === errors[k].id.toString()) {
                        passengers[i].view.errorList = errors[k].errors;
                        while (!isFound && j < passengers.length) {
                            if (passengers[i].id === passengers[j].relatedParentId) {
                                passengers[j].view.errorList = errors[k].errors;
                                isFound = true;
                            }
                            j++;
                        }
                    }
                }
            }

            function cleanDataError (passengers) {
                let i;
                for (i = 0; i < passengers.length; i++) {
                    passengers[i].view.errorList = [];
                }
            }
        }


        /**
         * Return the position of first passenger selected with error
         * @param {Array} passengerList List of passenger selected for continue flow and show in apis
         * @param {Array} errorPassengerList List of errors recived of service of APIS
         */
        function getPositionPassenger (passengerList, errorPassengerList) {
            let i = 0, isFound = false, positionPassenger;

            while (!isFound && i < passengerList.length) {
                if (errorPassengerList[0].id.toString() === passengerList[i].id) {
                    isFound = true;
                    positionPassenger = i;
                }
                i++;
            }

            return positionPassenger;
        }
    }

})();
